import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { DisplayTextMedium } from 'Packages/FacetDesign/Components';


export default buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => DisplayTextMedium,
  }, overrideReadOnly);
